import { FunctionComponent, memo, useContext } from "react";
import Modal, { ModalContent, ModalHeader, useModal } from "@edgetier/modal";
import { EllipsisMenuContext, EllipsisMenuItem } from "@edgetier/client-components";
import { IProps } from "./choose-tag-action.types";
import ChooseTagForm from "components-for/agents/choose-tag-form";
import "./choose-tag-action.scss";

/**
 * Options menu item for choosing a tag
 */
const ChooseTagAction: FunctionComponent<IProps> = () => {
    const { lockOpen, unlock } = useContext(EllipsisMenuContext);
    const { openModal, closeModal, modalProps } = useModal({ onCloseModal: unlock });

    return (
        <>
            <Modal {...modalProps}>
                <ModalHeader>
                    <h2>Choose Tag</h2>
                </ModalHeader>
                <ModalContent>
                    <ChooseTagForm closeAction={closeModal} />
                </ModalContent>
            </Modal>

            <EllipsisMenuItem
                closeAfterClick={false}
                onClick={() => {
                    lockOpen();
                    openModal();
                }}
            >
                Choose tag
            </EllipsisMenuItem>
        </>
    );
};

export default memo(ChooseTagAction);
